module.exports = __webpack_public_path__ + "img/product3.0122ce50.png";